import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { useState } from "react";
import { Link } from "react-router-dom";
import LatestUpdates from "./latestupdates";
import Footer from './footer';
import { motion } from "framer-motion";
import "./img.css";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram,FaArrowLeft, FaCalendarAlt } from "react-icons/fa";
import { Card, ListGroup, Button, Table } from "react-bootstrap";


const ProfessionalYear = () => {
  return (

    <>
      <Container className="mt-5">
        <Row>
          {/* Left Section - Image and Title */}


          <Col md={8} className="d-flex flex-column align-items-center text-center">
            <Image src="./img/professional.jpg" alt="Professional Year" fluid />
            <h2 className="mt-3">Professional Year</h2>
          </Col>


          {/* Right Section - Latest Posts and Social Media */}
          <Col md={4}>
                        <Card>
                            <Card.Header className="fw-bold">Latest Posts</Card.Header>
                            <ListGroup variant="flush">
                                <ListGroup.Item><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">   Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
                                 <ListGroup.Item><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/skilled-regional-191"className="dropdown-item text-decoration-none"style={{ color: "#22327f" }}target="_blank"rel="noopener noreferrer">Permanent Residence visa (Subclass 191)</a></ListGroup.Item>
                                {/* <ListGroup.Item><Link to="/regionalvisa" className="dropdown-item"><a href="" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</a></Link></ListGroup.Item> */
                                <ListGroup.Item><Link to="/tempactivity" className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
}
                            </ListGroup>
                        </Card>
                    </Col>
        </Row>
      </Container>

      <SecondSection />
      
      <LatestUpdates/>
       <Footer />    </>
  );

};

export default ProfessionalYear;

const SecondSection = () => {
  return (
    <Container fluid className="mt-4">
      <Row>
        {/* Left Side: Video Section */}
        <Col md={9}>
          <Row className="text-center mb-4">
            <Col md={6}>
              <h4>English</h4>
              <div className="embed-responsive embed-responsive-16by9">
                <iframe
                  className="embed-responsive-item"
                  src="https://www.youtube.com/embed/flqSOMIY0tY"
                  title="English Video"
                  allowFullScreen
                ></iframe>
              </div>
            </Col>
            <Col md={6}>
              <h4>Punjabi</h4>
              <div className="embed-responsive embed-responsive-16by9">
                <iframe
                  className="embed-responsive-item"
                  src="https://www.youtube.com/embed/1QDcKYP2rFM"
                  title="Punjabi Video"
                  allowFullScreen
                ></iframe>
              </div>
            </Col>
          </Row>

          {/* Description Section */}
          <p>
            The Professional Year Program is a professional development program
            involving formal learning and hands-on work experience for
            international graduates in Australia.
          </p>
          <p>
          This programmed is structured to enhance the abilities of Engineering/IT/Accounting Students so that 
          they can pursue their desire career. The Professional Year is a bridging course which helps students 
          complete a 12 weeks internship program in an industry related to their graduation. The program as a 
          whole, runs for 44 weeks of which 12 weeks are an Internship wherein the student is fine-tuned so 
          that they can be introduced to and learn the workplace culture. This internship helps the student 
          to develop their communication skills, workplace culture, technical knowledge for their role and team skills
          </p>
          <p>
          The Professional Year Program is excellent to help kick stAAT your career in Australia, and even has the 
          additional benefit of giving students additional points in a permanent residency Visa application (GSM visa).
          </p>
          <h4>BASIC ELIGIBILITY</h4>
          <p>You must:</p>
          <ul>
            <li>have completed an undergraduate or postgraduate (Bachelor or Master) award in Australia in 
            Accounting/IT/Engineering</li>
            <li>hold or applied for a Temporary Graduate visa (subclass 485, either stream) with at 
              least 12 months validity or;</li>
              <li>hold an eligible Secondary Visa with work and study rights with at least 12 months validity</li>
              <li>provide evidence of English language proficiency (Minimum 6 each band in IELTS)</li>
              <li>provide a valid skills assessment from a relevant professional association</li>
 </ul>
 <h4>BENEFITS</h4>
 <ul>
  <li>You will gain 5 points for permanent residency application (General Skill Migration visa)</li>
  <li>You will have a chance to meet the industry expert and helps develop your network with industry professional</li>
  <li>Add value to your Resume</li>
  <li>You will get an opportunity to develop professional skills through Internship</li>
 </ul>

 <h4>STREAMS</h4>
 <ul>
  <h6>SKILL MIGRATION INTERNSHIP PROGRAM – ACCOUNTING (SMIPA)</h6>
  <p>The Skill Migration Internship Program- Accounting (SMIPA) is available to all graduates who completed at 
    least two years Bachelor or Master Accounting Degree in Australia. This program is designed to help you 
    develop your career in Accounting through job placement.</p>
    <h6>IT PROFESSIONAL YEAR PROGRAM</h6>
    <p>This program is endorsed and developed by the Australian Computer Society (ACS). This program provides 
      opportunity to recent IT graduates to have practical skills and training through 12 Week internship program.</p>
      <h6>ENGINEERING PROFESSIONAL YEAR PROGRAM</h6>
      <p>​The Professional Year in Engineering program is the program run by various provider in association with Australian 
        Government. This program develops and enhance the skill of recent engineering graduate.</p>
 </ul>
 <motion.a
  href="https://au.bajwaimmigration.com/book-appointment"
  target="_blank"
  rel="noopener noreferrer"
  initial={{ x: "-100vw", opacity: 0 }}
  animate={{ x: 0, opacity: 1 }}
  transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
  className="btn btn-danger btn-sm position-fixed bottom-0 start-0 m-3 text-white text-decoration-none"
  style={{ zIndex: 1050 }}
>
  <i className="bi bi-chat-left-text me-1"></i>
  Consult Now
</motion.a>

        </Col>

        {/* Right Side: Sidebar Section (Reduced width + Added space) */}
        <Col md={3} > {/* Added margin-left (ms-4) */}
          <Card className="p-3 text-center">
            {/* Bajwa Immigration Image */}
            <Image
              src="./img/brand-logo.png"
              alt="Bajwa Immigration Logo"
              fluid
              className="mb-3"
            />

            <h6 className="fw-bold">Subscribe to our YouTube channel</h6>
            <Button variant="danger" className="mb-3"><a href="https://www.youtube.com/embed/uOGAB9oYets">SUBSCRIBE</a></Button>

            <h6 className="fw-bold">Book Consultation</h6>
            <Button variant="warning">BOOK CONSULTATION</Button>

            <h6 className="fw-bold mt-3">Like Us on Facebook !!</h6>
            {/* Facebook Embed */}
            <iframe
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FBajwaImmigration&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
              width="100%"
              height="130"
              style={{ border: "none", overflow: "hidden" }}
              scrolling="no"
              frameBorder="0"
              allowFullScreen
            ></iframe>

            {/* Social Media */}
            <h6 className="fw-bold mt-3">We are also on:</h6>
            <div className="d-flex justify-content-center gap-3">
              <FaInstagram size={30} color="#C13584" />
              <FaTiktok size={30} color="#000" />
              <FaYoutube size={30} color="crimson" />
            </div>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};